(window.theme = window.theme || {}),
    (theme.init = function () {
        theme.retinaImages(),
            theme.relatedProductItem(),
            theme.animateScrollTo(),
            theme.prodDetailTooltip(),
            theme.reviewDate(),
            theme.instagramSlider(),
            theme.strapUpsell(),
            theme.productMobileSlider();
    }),
    (theme.retinaImages = function () {
        $(window).load(function () {
            !(function () {
                function b(a) {
                    return Array.prototype.slice.call(a);
                }
                function j(a) {
                    var b = parseInt(a, 10);
                    return b > n ? n : b;
                }
                function k(a) {
                    return (
                        a.hasAttribute("data-no-resize") ||
                            (0 === a.offsetWidth && 0 === a.offsetHeight
                                ? (a.setAttribute("width", a.naturalWidth), a.setAttribute("height", a.naturalHeight))
                                : (a.setAttribute("width", a.offsetWidth), a.setAttribute("height", a.offsetHeight))),
                        a
                    );
                }
                function m(a, b) {
                    var c = a.nodeName.toLowerCase(),
                        d = document.createElement("img");
                    d.addEventListener("load", function () {
                        "img" === c ? k(a).setAttribute("src", b) : (a.style.backgroundImage = "url(" + b + ")");
                    }),
                        d.setAttribute("src", b),
                        a.setAttribute(g, !0);
                }
                function p(b, c) {
                    var d = 2 >= arguments.length || void 0 === arguments[2] ? 1 : arguments[2],
                        e = j(d);
                    if (c && 1 < e) {
                        var g = c.replace(f, "@" + e + "x$1");
                        m(b, g);
                    }
                }
                function i(a, b, c) {
                    1 < n && m(a, c);
                }
                function e(a) {
                    return a
                        ? "function" == typeof a.forEach
                            ? a
                            : b(a)
                        : "undefined" == typeof document
                          ? []
                          : b(document.querySelectorAll(l));
                }
                function o(a) {
                    return a.style.backgroundImage.replace(c, "$2");
                }
                function a(a) {
                    e(a).forEach(function (b) {
                        if (!b.getAttribute(g)) {
                            var c = "img" === b.nodeName.toLowerCase(),
                                d = c ? b.getAttribute("src") : o(b),
                                e = b.getAttribute("data-rjs"),
                                f = !isNaN(parseInt(e, 10));
                            f ? p(b, d, e) : i(b, d, e);
                        }
                    });
                }
                "undefined" == typeof exports && (exports = {}),
                    Object.defineProperty(exports, "__esModule", { value: !0 });
                var d = "undefined" != typeof window,
                    n = d ? window.devicePixelRatio || 1 : 1,
                    f = /(\.[A-z]{3,4}\/?(\?.*)?)$/,
                    c = /url\(('|")?([^\)'"]+)('|")?\)/i,
                    l = "[data-rjs]",
                    g = "data-rjs-processed";
                d && (window.addEventListener("load", a), (window.retinajs = a)), (exports["default"] = a);
            })(),
                retinajs();
        });
    }),
    (theme.relatedProductItem = function () {
        $(".related-product__slider").slick({
            fade: !1,
            arrows: !0,
            dots: !1,
            slide: ".related-product__slide",
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: '<span class="slick-arrow slick-prev icon icon-chevron-left lefty"></span>',
            nextArrow: '<span class="slick-arrow slick-next icon icon-chevron-right righty"></span>',
            responsive: [{ breakpoint: 768, settings: { slidesToShow: 3, arrows: !1, dots: !0 } }],
        }),
            $(".related-product__slider").on("click", ".prod-block__swatch", function () {
                var a = $(this).parents(".related-product__slide"),
                    b = $(this).attr("data-src");
                a.find(".prod-block__image").animate({ opacity: 0 }, 300, function () {
                    $(this).siblings().attr("srcset", b).attr("src", b),
                        $(this).one("load", function () {
                            $(this).animate({ opacity: 1 }, 300);
                        });
                });
                var c = $(this).attr("data-url");
                a.find("a").attr("href", c);
                var d = $(this).attr("data-price"),
                    e = $(this).attr("data-compare-price"),
                    f = $(this).attr("data-raw-price");
                a.find(".prod-block__price").html(d),
                    a.find(".prod-block__price-compare").html(e),
                    a.find(".prod-block").attr("data-price", f);
                var g = $(this).attr("data-stock");
                a.find(".prod-block__stock").html(g),
                    a.find(".prod-block__swatch").removeClass("selected"),
                    $(this).addClass("selected");
            });
    }),
    (theme.animateScrollTo = function () {
        $('.product a[href^="#"]').click(function (a) {
            a.preventDefault();
            var b = this.hash;
            "undefined" != typeof $(b).offset() && $("html, body").animate({ scrollTop: $(b).offset().top - 60 }, 500);
        }),
            $(".product__back-top").on("click", function () {
                $("html, body").animate({ scrollTop: 0 }, 500);
            });
    }),
    (theme.prodDetailTooltip = function () {
        $(".product-details__fabric-list-item").on("mouseenter", function () {
            $(".product-details__fabric-list-item").removeClass("active"), $(this).addClass("active");
        }),
            $(".product-details__fabric-list-item").on("mouseleave", function () {
                $(this).removeClass("active");
            });
    }),
    (theme.videoModal = function () {
        $(".videoModal").find(".product-video").removeAttr("id");
        var a = $(".videoModal").find(".product-video__video").html();
        $(".videoModal").find(".modal-body").html(a);
    }),
    (theme.reviewDate = function () {
        $(window).load(function () {
            setTimeout(function () {
                $(".stamped-carousel-scroll-wrapper .block").each(function () {
                    var a = $(this).find(".stamped-reviews-date").text();
                    $(this)
                        .find(".stamped-reviews-author")
                        .prepend("- ")
                        .append('<span class="review-date">, ' + a + "</span>");
                });
            }, 500);
        });
    }),
    (theme.instagramSlider = function () {
        var a = !1,
            b = function () {
                768 > $(window).width()
                    ? !1 == a &&
                      ($(".fs-timeline").slick({ fade: !1, arrows: !1, dots: !0, slidesToShow: 3, slidesToScroll: 1 }),
                      (a = !0))
                    : (!0 == a && $(".fs-timeline").slick("destroy"), (a = !1));
            };
        $(window).load(function () {
            b(),
                setTimeout(function () {
                    b();
                }, 1e3);
        }),
            $(window).resize(function () {
                b();
            });
    }),
    (theme.strapUpsell = function () {
        $(".strap__swatches li").on("click", function () {
            var a = parseFloat($(this).attr("data-vprice") / 100).toFixed(2),
                b = $(this).attr("data-val"),
                c = $(this).attr("data-val").replace(/ /g, "-").toLowerCase(),
                d = $(this).attr("data-varimgsrc"),
                e = $(this).find("input").val(),
                f = $(this).attr("data-option-title");
            $(".strap__swatches li").removeClass("selected"),
                $(this).addClass("selected"),
                $(this).find("input").attr("checked", !0),
                $(this).closest("form").find("#productSelect").val(f),
                $(".extra-strap__price .money").text("$" + a),
                $(".strap__swatches .swatch-variant-title").text(""),
                $(this).parent().prev("h4").find(".swatch-variant-title").text(b),
                $(this).hasClass("soldout")
                    ? $(this)
                          .closest("form")
                          .find("#add-to-cart")
                          .addClass("back-order")
                          .attr("disabled", "disabled")
                          .val("Out of stock")
                    : $(this)
                          .closest("form")
                          .find("#add-to-cart")
                          .removeClass("back-order")
                          .attr("disabled", !1)
                          .attr("value", "ADD TO CART"),
                $(".extra-strap__more-info a").attr("href", "?variant=" + f),
                $(".extra-strap__image img").attr("src", "//cdn.shopify.com/s/files/1/0082/8872/" + d);
            var g = "//cdn.shopify.com/s/files/1/0082/8872/" + $(this).attr("data-varimgsrc");
            $(".selected-product-info h5").text($(".extra-strap__title h2").text()),
                $(".selected-product-info .variant-price .money").text(a),
                $(".selected-var-modal-img").attr("src", g),
                $(".option1cart").hide(),
                $(".option2cart").hide(),
                $(".option3cart").hide();
        }),
            $('.extra-strap__submit input[type="submit"]').on("click", function () {
                $("#extraStrapModal").modal("hide");
            });
    }),
    (theme.productMobileSlider = function () {
        var a = !1,
            b = function () {
                768 > $(window).width()
                    ? !1 == a
                        ? ($(".product-single__photo-slider").slick({
                              fade: !1,
                              arrows: !1,
                              dots: !0,
                              slidesToShow: 1,
                              slidesToScroll: 1,
                              infinite: !1,
                          }),
                          $(".product-single__photo-slider").slick("slickUnfilter"),
                          $(".product-single__photo-slider").slick("slickFilter", ".variant-active, .photo-active"),
                          (a = !0))
                        : ($(".product-single__photo-slider").slick("slickUnfilter"),
                          $(".product-single__photo-slider").slick("slickFilter", ".variant-active, .photo-active"))
                    : (!0 == a &&
                          ($(".product-single__photo-slider").slick("slickUnfilter"),
                          $(".product-single__photo-slider").slick("destroy")),
                      (a = !1));
            };
        $(window).load(function () {
            b();
        }),
            $(window).resize(function () {
                b();
            });
    }),
    $(theme.init);
